module.exports = __webpack_public_path__ + "static/media/current-location.e9e4566d.svg";